// extracted by mini-css-extract-plugin
export default {"label":"FmAEtki1NljQffhCZpYR"};